export default "__VITE_ASSET__AmO7bnVB__"